import { User } from './user.model'

export enum EventType {
  EventTypeTicketCreated = 'ticket_created',
  EventTypeTicketUpdated = 'ticket_updated',
  EventTypeTicketStatusChanged = 'status_changed',
  EventTypeAssign = 'assign',
  EventTypeMention = 'mention',
  EventTypeComment = 'comment',
  EventTypeDesignTaskUpdated = "design_task_updated",
  EventTypeDesignTaskAssign = "design_task_assign",
  EventTypeDesignTaskUnassign = "design_task_unassign",
  EventTypeFabTaskUpdated = "fab_task_updated",
  EventTypeFabTaskAssign = "fab_task_assign",
  EventTypeFabTaskUnassign = "fab_task_unassign",
}

export interface NotificationGroup {
  key: string
  title: string
  icon: string
  eventTypes: EventType[]
}

// empty eventTypes = no filter
export const NOTIFICATION_GROUPS: NotificationGroup[] = [
  {
    key: 'all',
    title: 'All',
    icon: 'bell',
    eventTypes: [],
  },
  {
    key: 'cases',
    title: 'Cases',
    icon: 'folder',
    eventTypes: [EventType.EventTypeTicketUpdated, EventType.EventTypeAssign],
  },
  {
    key: 'comments',
    title: 'Comments',
    icon: 'message',
    eventTypes: [EventType.EventTypeComment],
  },
  {
    key: 'design_tasks',
    title: 'Design Tasks',
    icon: 'highlight',
    eventTypes: [
      EventType.EventTypeDesignTaskUpdated,
      EventType.EventTypeDesignTaskAssign,
      EventType.EventTypeDesignTaskUnassign,
    ],
  },
  {
    key: 'fab_tasks',
    title: 'Fabrication Tasks',
    icon: 'tool',
    eventTypes: [
      EventType.EventTypeFabTaskUpdated,
      EventType.EventTypeFabTaskAssign,
      EventType.EventTypeFabTaskUnassign,
    ],
  },
]

export class Notification {
  id: number
  createdAt: Date
  author: User
  ticketId: number
  designTaskId: number
  type: EventType
  read: boolean

  constructor(data?: any) {
    this.id = data?.id
    this.createdAt = data?.createdAt
    this.author = new User(data?.author)
    this.ticketId = data?.ticketId
    this.type = data?.type
    this.read = data?.read
    this.designTaskId = data?.designTaskId
  }
}

export class MarkAsReadPayload {
  markAll?: boolean
  notificationIds?: number[]
  eventTypes?: EventType[]
}

export class NotificationUnreadEventTypeCount {
  eventType: EventType
  unreadCount: number

  constructor(data?: any) {
    this.eventType = data?.eventType
    this.unreadCount = data?.unreadCount
  }
}

export class NotificationUnread {
  unreadCount: number
  // event types without unread notifications are omitted
  unreadCountByEventType: NotificationUnreadEventTypeCount[]

  constructor(data?: any) {
    this.unreadCount = data?.unreadCount
    this.unreadCountByEventType = (data?.unreadCountByEventType || []).map((c: any) => new NotificationUnreadEventTypeCount(c))
  }
}
